




































































import { Component, Prop, Mixins } from "vue-property-decorator"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import { sendMessage } from "@/api/notices"
import { IRecipient } from "@/entities/notices"
import SelectedRecipientPills from "@/components/Notices/SelectedRecipientPills.vue"
import DesktopRecipientPicker from "@/components/Notices/DesktopRecipientPicker.vue"
import Loading from "@/components/Loading.vue"
import Typography from "@/components/Rain/Typography/Typography.vue"
import Modal from "@/components/Modal.vue"
import BaseButton from "@/components/Rain/Buttons/BaseButton.vue"
import NoticeSchedulerModal from "@/components/Notices/NoticeSchedulerModal.vue"
import Quote from "@/components/Notices/Quote.vue"
import ChatInput from "@/components/Chat/ChatInput.vue"
import NoticesMixin from "@/components/Notices/notices-mixin"

@Component<ChatShoutoutComposer>({
    components: {
        FontAwesomeIcon,
        BaseButton,
        ChatInput,
        DesktopRecipientPicker,
        Loading,
        Modal,
        NoticeSchedulerModal,
        SelectedRecipientPills,
        Typography,
        Quote
    }
})
export default class ChatShoutoutComposer extends Mixins(NoticesMixin) {

    private showRecipientPicker = false
    private loading = false
    private composerMessage = ''
    private sending = false

    @Prop({ type: Object, required: true}) private question!: { id: number, comment: string }
    @Prop({ type: Function, required: true}) private closeEditor!: Function

    public async beforeMount() {
        this.loading = true
        this.setComposerQuestion({ id: Number(this.question.id), comment: this.question.comment })
        this.setComposerNoticeType('shoutout')

        if (!this.recipients?.length) {
            await this.loadRecipients()
        }
        this.setComposerRecipients(this.responseShoutoutRecipients)
        this.loading = false
    }

    public beforeDestroy() {
        this.resetComposer()
    }

    private onConfirmRecipients(selectedRecipients: IRecipient[]) {
        this.setComposerRecipients(selectedRecipients)
        this.setShowRecipientPickerModal(false)
    }

    public get canSend() {
        return (
            !this.sending &&
            this.contentLength > 0 &&
            this.contentLength < this.contentLengthLimit &&
            this.composer?.recipients.length
        )
    }

    private setShowRecipientPickerModal(show: boolean) {
        this.showRecipientPicker = show
    }

    private async sendResponseShoutoutNotice() {
        if (!this.canSend) {
            return
        }

        this.sending = true

        const { data } = await sendMessage(this.composer)

        if (data.success) {
            this.notifySuccess(data, "Shoutout sent")
            this.closeEditor()
            this.resetComposer()
        } else {
            this.notifyError(data)
        }

        this.sending = false
    }

    public get responseShoutoutRecipients() {
        if(this.recipients && this.recipients.length) {
            return [this.recipients.find(recipient => recipient.field === 'everyone')]
        }
        return []
    }
}
